export default __webpack_public_path__ + "static/media/ECB-Logo.a1bf0ca6.jpg";